import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Typography from '@mui/material/Typography';
import { useCallback } from 'react';
import { shallowEqual } from 'react-redux';
import { createJoinOutbound } from '../../../api/outbound/lobbyOutbounds';
import { useSocketSend } from '../../../context/webSocket/webSocketContext';
import { useAppSelector } from '../../../redux/store';
import { ROOM_NAME_HYPERLINK_CSS } from '../../../styles/styles';
import { getHtmlTextContent } from '../../../utils/htmlUtils';
import { RoomDisplayContainer, RoomDisplayFirstRowContainer, RoomDisplaySecondRowContainer } from '../../lobby/lobbyRoomDisplay';
const ROOM_NAME_CSS = ROOM_NAME_HYPERLINK_CSS;
function getStatus(statusString) {
    if (statusString) {
        if (!isNaN(Number(statusString))) {
            // statusString can be parsed as a number and is therefore the number of active players:
            return `${statusString} playing`;
        }
        return statusString;
    }
}
export const MttStagingTableDisplay = ({ mttStagingTableIndex }) => {
    const mttStagingTable = useAppSelector((state) => state.mttStaging.mttStagingTables[mttStagingTableIndex], shallowEqual);
    const isFinalActiveTable = useAppSelector((state) => mttStagingTable.isActive &&
        state.mttStaging.mttStagingTables.reduce((acc, curr) => acc + (curr.isActive ? 1 : 0), 0) === 1);
    const socketSend = useSocketSend();
    const onClick = useCallback(() => {
        socketSend(createJoinOutbound(mttStagingTable.roomId));
    }, [mttStagingTable.roomId, socketSend]);
    const status = getStatus(mttStagingTable.statusString);
    const tableName = `Table ${mttStagingTable.tableNum}`;
    return (_jsxs(RoomDisplayContainer, { "aria-label": tableName, isDimmed: !mttStagingTable.isActive, onClick: onClick, children: [_jsxs(RoomDisplayFirstRowContainer, { "aria-hidden": true, children: [_jsx("span", { css: ROOM_NAME_CSS, children: isFinalActiveTable ? 'Final Table' : tableName }), status && _jsxs(Typography, { variant: 'caption', children: ["(", status, ")"] })] }), mttStagingTable.playersStringHtml && (_jsx(RoomDisplaySecondRowContainer, { "aria-hidden": true, children: _jsx(Typography, { variant: 'caption', children: getHtmlTextContent(mttStagingTable.playersStringHtml) }) }))] }));
};
